import React, { useState } from "react";
import { Text, View } from "react-native";
import CText from "./CText";
import { Slider } from "@sharcoux/slider";

const CSlider = ({ children, inputWithTopLabel, ...otherProps }) => {
  const [minAmount, setMinAmount] = useState(0);

  const handleValueChange = (val) => {
    setMinAmount(val);
    otherProps.onValueChange(val);
  };

  return (
    <View style={styles.inputWrapper}>
      <CText.inputTopLabel>{otherProps.label}</CText.inputTopLabel>
      <View style={styles.sliderWrapper}>
        <Slider
          range={[0, 100]} // set the current slider's value
          minimumValue={100000} // Minimum value
          maximumValue={1000000} // Maximum value
          step={50000} // The step for the slider (0 means that the slider will handle any decimal value within the range [min, max])
          minimumRange={1} // Minimum range between the two thumbs
          crossingAllowed={false} // If true, the user can make one thumb cross over the second thumb
          outboundColor="#ff8b38" // The track color outside the current range value
          inboundColor="#ff8b38" // The track color inside the current range value
          thumbTintColor="#ff8b38" // The color of the slider's thumb
          thumbStyle={undefined} // Override the thumb's style
          trackStyle={undefined} // Override the tracks' style
          minTrackStyle={undefined} // Override the tracks' style for the minimum range
          midTrackStyle={undefined} // Override the tracks' style for the middle range
          maxTrackStyle={undefined} // Override the tracks' style for the maximum range
          vertical={false} // If true, the slider will be drawn vertically
          inverted={false} // If true, min value will be on the right, and max on the left
          enabled={true} // If false, the slider won't respond to touches anymore
          trackHeight={4} // The track's height in pixel
          thumbSize={15} // The thumb's size in pixel
          thumbImage={undefined} // An image that would represent the thumb
          slideOnTap={true} // If true, touching the slider will update it's value. No need to slide the thumb.
          onValueChange={""} // Called each time the value changed. The type is (range: [number, number]) => void
          onSlidingStart={undefined} // Called when the slider is pressed. The type is (range: [number, number]) => void
          onSlidingComplete={handleValueChange} // Called when the press is released. The type is (range: [number, number]) => void
          {...otherProps} // Add any View Props that will be applied to the container (style, ref, etc)
        />
        <View style={styles.valueWrapper}>
          <View>
            <Text>Min</Text>
            <Text>₹ 1,00,000</Text>
          </View>
          <View>
            <Text style={{ textAlign: "right" }}>Max</Text>
            <Text>₹ 1,00,00,000</Text>
          </View>
        </View>
      </View>
    </View>
  );
};
// const useStyles = CreateResponsiveStyle(
const styles = {
  sliderWrapper: {
    backgroundColor: "#fff",
    borderRadius: 6,
    width: 299,
  },
  valueWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  inputWrapper: {},
};

export default CSlider;
